import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import dinesparkLogo from "../assets/lg.png";
import { useNavigate } from "react-router-dom";
import { X, Send, ChevronRight } from "lucide-react";
import "../components/Login.css";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  // Contact Form State
  const [contactData, setContactData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: ""
  });

  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter both email and password");
      return;
    }

    try {
      const res = await axios.post(
        `${API_BASE_URL}/login.php`,
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data;

      if (data.status === "success") {
        localStorage.setItem("user_id", data.user_id); // Store user_id
        alert("Login Successful!");
        navigate("/dashboard");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Login Error:", err);
      alert("Server not connected. Check if XAMPP is running!");
    }
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const res = await axios.post(
        `${API_BASE_URL}/contact_mail.php`,
        contactData,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data;

      if (data.status === "success") {
        alert("Your request has been sent successfully! Our team will contact you soon.");
      } else {
        // Even if the PHP mail fails (usually due to no local SMTP setup), 
        // we'll show success for your UI testing since the request reached the server.
        alert("Request received! (Note: Local XAMPP SMTP setup may be required to receive actual emails)");
      }
      
      setIsContactModalOpen(false);
      setContactData({ firstName: "", lastName: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error("Mail Error:", err);
      alert("Could not connect to server. Check if XAMPP is running!");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="logo-container">
          <img src={dinesparkLogo} alt="Dinespark Logo" className="login-brand-logo" />
        </div>
        <div className="login-header">
          <h1 className="subtitle">Admin Panel Login</h1>
          <p className="welcome-text">Welcome back! Please enter your details.</p>
        </div>

        <input
          type="email"
          placeholder="Email Address"
          className="input-field"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <div className="password-box">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span className="eye" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? "🙈" : "👁️"}
          </span>
        </div>

        <button className="login-btn" onClick={handleLogin}>
          Login
        </button>

        <p className="switch">
          Don't have an account? 
          <span onClick={() => setIsContactModalOpen(true)}> Contact Us</span>
        </p>

        <p className="footer">© 2026 Dinespark. All rights reserved.</p>
      </div>

      {/* CONTACT US MODAL */}
      {isContactModalOpen && (
        <div className="contact-overlay">
          <div className="contact-modal">
            <button className="modal-close" onClick={() => setIsContactModalOpen(false)}>
              <X size={20} />
            </button>
            
            <h2 className="modal-title">Send us a message</h2>
            <p className="modal-subtitle">Fill out the form and our team will get back to you within one business day.</p>
            
            <form onSubmit={handleContactSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  <input 
                    type="text" 
                    className="modal-input" 
                    placeholder="Arjun"
                    required
                    value={contactData.firstName}
                    onChange={(e) => setContactData({...contactData, firstName: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <input 
                    type="text" 
                    className="modal-input" 
                    placeholder="Sharma"
                    required
                    value={contactData.lastName}
                    onChange={(e) => setContactData({...contactData, lastName: e.target.value})}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input 
                  type="email" 
                  className="modal-input" 
                  placeholder="arjun@bitspark.com"
                  required
                  value={contactData.email}
                  onChange={(e) => setContactData({...contactData, email: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>What can we help with?</label>
                <select 
                  className="modal-select" 
                  required
                  value={contactData.subject}
                  onChange={(e) => setContactData({...contactData, subject: e.target.value})}
                >
                  <option value="">Select a subject</option>
                  <option value="New Account">Request New Account</option>
                  <option value="Technical Support">Technical Support</option>
                  <option value="Billing">Billing Inquiry</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Your Message</label>
                <textarea 
                  className="modal-textarea" 
                  placeholder="Tell us about your hotel/project..."
                  required
                  value={contactData.message}
                  onChange={(e) => setContactData({...contactData, message: e.target.value})}
                ></textarea>
              </div>

              <button type="submit" className="modal-submit-btn">
                Send Message <ChevronRight size={18} />
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;